module.exports = __webpack_public_path__ + "static/img/pic_szh_zhptyy_gk_lb1@2x.732273f1.png";